import { pull, union } from 'lodash/fp';
import storage from 'store2';

/**
 * The localStorage key for the waiting referral tokens queue.
 * @type {string}
 */
export const WAITING_REFERRAL_TOKENS = `waiting_referral_tokens`;

/**
 * The logic prioritizes later-defined referral tokens (last used wins, LIFO),
 * thus new referralToken is prepended to the queue.
 * @param {string} referralToken - the referral token to be stored to the BE.
 * @return {void}
 */
export const prependWaitingReferralToken = (referralToken) => {
	storage.transact(WAITING_REFERRAL_TOKENS, union([referralToken]));
};

/**
 * Returns queue of all waiting referral tokens.
 * @return {string[]}
 */
export const getWaitingReferralTokens = () => storage.get(WAITING_REFERRAL_TOKENS);

/**
 * Clears-out all the waiting referral tokens queue
 */
export const clearWaitingReferrals = () => {
	storage.remove(WAITING_REFERRAL_TOKENS);
};

/**
 * Deletes passed referral token from the queue.
 * @param {string} referralToken
 * @return {void}
 */
export const deleteWaitingReferralToken = (referralToken) => {
	storage.transact(WAITING_REFERRAL_TOKENS, pull(referralToken));
};
